exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "home .content{display:flex;flex-direction:column;align-items:center;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/home.scss
// module id = 613
// module chunks = 0